import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCsvImportIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 56 56",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M49.55 14.8v29.7c0 .911-.74 1.65-1.65 1.65H11.6a1.65 1.65 0 0 1-1.65-1.65V14.8c0-.911.739-1.65 1.65-1.65h36.3c.911 0 1.65.739 1.65 1.65Z",
			stroke: "#4d4540",
			strokeWidth: 1.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.95 10.4v4.4a.55.55 0 0 1-.55.55H5a.55.55 0 0 1-.55-.55v-4.4A.55.55 0 0 1 5 9.85h15.4a.55.55 0 0 1 .55.55Z",
			fill: "#fff",
			stroke: "#fe7933",
			strokeWidth: 1.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.05 29.65h-7.7v-5.5h7.7zm0 5.5h-7.7v-5.5h7.7zm0 5.5H14.9a.55.55 0 0 1-.55-.55v-4.95h7.7zm7.7-11h-7.7v-5.5h7.7zm7.7 0h-7.7v-5.5h7.7z",
			stroke: "#4d4540",
			strokeWidth: 1.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.15 29.65h-7.7v-5.5h7.7zm-15.4 5.5h-7.7v-5.5h7.7zm7.7 0h-7.7v-5.5h7.7z",
			stroke: "#4d4540",
			strokeWidth: 1.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.15 35.15h-7.7v-5.5h7.7zm-15.4 5.5h-7.7v-5.5h7.7zm7.7 0h-7.7v-5.5h7.7zm7.7-.55a.55.55 0 0 1-.55.55h-7.15v-5.5h7.7z",
			stroke: "#4d4540",
			strokeWidth: 1.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.05 24.15h-7.7V19.2a.55.55 0 0 1 .55-.55h7.15z",
			stroke: "#fe7933",
			strokeWidth: 1.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.75 24.15h-7.7v-5.5h7.7zm7.7 0h-7.7v-5.5h7.7z",
			stroke: "#fe7933",
			strokeWidth: 1.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.15 19.2v4.95h-7.7v-5.5h7.15a.55.55 0 0 1 .55.55Z",
			stroke: "#fe7933",
			strokeWidth: 1.1,
			strokeLinecap: "round"
		})
	]
});
export default SvgCsvImportIcon;
